module.exports = __webpack_public_path__ + "static/20211221-banner-disco-fimo-emborrachado-c875d5c3101f091e8a6e77decdd01a1c.webp";